import { apiClient as api } from './apiClient';

export interface Titular {
  id: number;
  codigo: string;
  nombreCompleto: string;
}

export interface AuraFarmaciaResponse {
  idAQ: number;
  titulares?: Titular[];
  empleados?: Titular[];
}

/**
 * Gets the current titulares (owners) of a pharmacy from Gedeco.
 * @param idFarmacia Pharmacy ID
 * @param usuario User ID making the request
 * @param opcion Option parameter (default: 2)
 */
export const getFarmaciaTitulares = async (
  idFarmacia: number,
  usuario: number,
  opcion: number = 2
): Promise<AuraFarmaciaResponse> => {
  try {
    const response = await api.get<AuraFarmaciaResponse>('/aura/farmacia', {
      params: { id_fcia: idFarmacia, usuario, opcion }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching farmacia titulares:', error);
    throw error;
  }
};
